import { Navigate, Route, Routes, useLocation } from 'react-router';
import { useSession } from './api/hooks.js';
import { AppShell } from './components/AppShell.js';
import { Mark } from './components/Mark.js';
import { SearchShell } from './components/SearchShell.js';
import { useSessionStore } from './store/session.js';
import { Home } from './screens/Home.js';
import { Login } from './screens/Login.js';
import { Placeholder } from './screens/Placeholder.js';
import { Profile } from './screens/Profile.js';
import { Record } from './screens/Record.js';
import { Records } from './screens/Records.js';
import { Results } from './screens/Results.js';
import { Review } from './screens/Review.js';
import { Settings } from './screens/Settings.js';

/**
 * Console routes (planner 2.2b), all under the `/app` basename set in
 * main.tsx. The session query runs once; until it answers the shell shows
 * only the mark. Signed out → the sign-in screen for every path (the
 * `?link=` reason from `/app/auth/:token` survives); signed in → the shell.
 */
export function App() {
  useSession();
  const status = useSessionStore((s) => s.status);
  const location = useLocation();

  if (status === 'unknown') {
    return (
      <main
        className="flex min-h-screen items-center justify-center bg-ground"
        aria-busy="true"
      >
        <Mark size={32} />
      </main>
    );
  }
  if (status === 'signed_out') {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to={`/login${location.search}`} replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<AppShell />}>
        {/* Home and results share the SearchShell layout: one search field,
            morphing between the hero and its docked position. */}
        <Route element={<SearchShell />}>
          <Route index element={<Home />} />
          <Route path="/search" element={<Results />} />
        </Route>
        <Route path="/entities/:id" element={<Profile />} />
        <Route path="/records" element={<Records />} />
        <Route path="/records/:id" element={<Record />} />
        <Route path="/review" element={<Review />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/watchlist" element={<Placeholder title="Watchlist" />} />
        <Route path="/alerts" element={<Placeholder title="Alerts" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
